// extracted by mini-css-extract-plugin
export default {"iframeScrollWrapper":"styles__iframeScrollWrapper--N7WXu","iframeContent":"styles__iframeContent--LQgiB","splashScreen":"styles__splashScreen--P7wkd","loadingWrapper":"styles__loadingWrapper--WcSep"};
    if(module.hot) {
      // 1734353973464
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  